import React, { Component } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { selectors as sessionSelectors } from "reducers/session";
import { func, shape, bool, arrayOf, string } from "prop-types";
import { withRouter } from "react-router-dom";
import { resizableRoute } from "pages/_components/Resizable";
import { actions as notificationActions } from "reducers/notification";
import { get as getMessage } from "util/i18n";
import WithPermissions from "./WithPermissions";

class WithPermissionsRedirect extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        permissions: arrayOf(string).isRequired,
        children: shape({}),
        comparator: func,
        somePermissions: bool,
    };

    static defaultProps = {
        children: null,
        comparator: null,
        somePermissions: false,
    };

    redirectFunc = () => {
        const { dispatch, permissions } = this.props;
        if (permissions != null && (permissions.includes("loans") || permissions.includes("accounts"))) {
            dispatch(
                notificationActions.showNotification(getMessage("products.operation.NoDispose"), "error", ["menu"]),
            );
        } else {
            dispatch(notificationActions.showNotification(getMessage("returnCode.COR005E"), "error", ["menu"]));
        }
        dispatch(push("/desktop"));
    };

    render() {
        const { permissions, children, comparator, somePermissions } = this.props;

        return (
            <WithPermissions
                somePermissions={somePermissions}
                permissions={permissions}
                comparator={comparator || null}
                redirectFunc={() => this.redirectFunc()}>
                {children}
            </WithPermissions>
        );
    }
}

function mapStateToProps(state) {
    return {
        activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    };
}

export default withRouter(connect(mapStateToProps)(resizableRoute(WithPermissionsRedirect)));
